import { withInstall } from '@hongluan-ui/utils'
import Header from '../layout/src/header.vue'

export const HlHeader = withInstall(Header)
export default HlHeader

